import { useQuery } from '@apollo/client';
import { useClient } from '../ClientContext';
import { GET_LEDGER_ACCOUNTS, GET_LEDGER_ACCOUNTS_BY_CLIENT } from './queries';
import { apolloV2Client } from '../../general-ledger/queries';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
import { SplitFeatureFlags } from '../features';

const useLedgerAccounts = () => {
  const client = useClient();

  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  const isAssignCategoryImprovementEnabled =
    features[SplitFeatureFlags.ASSIGN_CATEGORY_IMPROVEMENT]?.value === FeatureValue.FEATURE_ON;

  // Check if the feature flag has been loaded - if the feature exists in features object,
  // it means flags are loaded. If features is empty/undefined, flags haven't loaded yet.
  const featureFlagsLoaded = features && Object.keys(features).length > 0;

  // Use v2 query if feature flag is enabled, otherwise use v1
  const ledgerAccountsQuery = isAssignCategoryImprovementEnabled
    ? GET_LEDGER_ACCOUNTS_BY_CLIENT
    : GET_LEDGER_ACCOUNTS;

  const { loading, error, data } = useQuery(ledgerAccountsQuery, {
    variables: { clientId: client?.id },
    skip: !client?.id || !featureFlagsLoaded,
    client: isAssignCategoryImprovementEnabled ? apolloV2Client : undefined,
    context: isAssignCategoryImprovementEnabled ? { useV2: true } : undefined,
  });

  // Extract ledger accounts from response based on which query was used
  const ledgerAccounts = isAssignCategoryImprovementEnabled
    ? data?.ledgerAccountsByClient
    : data?.ledgerAccounts;

  return {
    ledgerAccounts: ledgerAccounts || [],
    isLoading: loading,
    hasError: error,
  };
};

export default useLedgerAccounts;
